export default __webpack_public_path__ + "static/media/dots_login.6f97fcf1.svg";